var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("中华人民共和国进境物品完税价格表")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"scroll"},_vm._l((25),function(i){return _c('img',{key:i,attrs:{"src":require('../../../assets/tax/page'+i+'.png'),"alt":""}})}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b75c6bcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/PageService/components/tax.vue
// module id = null
// module chunks = 